module.exports = __webpack_public_path__ + "img/satisfied_gray.35ad3b95.png";